import * as ambassadorWixLoyaltySocialmediaV1FollowedChannel from './loyalty-socialmedia-v1-followed-channel-social-media.http.js';
import * as ambassadorWixLoyaltySocialmediaV1FollowedChannelTypes from './loyalty-socialmedia-v1-followed-channel-social-media.types.js';
import * as ambassadorWixLoyaltySocialmediaV1FollowedChannelUniversalTypes from './loyalty-socialmedia-v1-followed-channel-social-media.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createFollowedChannel(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixLoyaltySocialmediaV1FollowedChannelUniversalTypes.CreateFollowedChannelRequest,
  ambassadorWixLoyaltySocialmediaV1FollowedChannelTypes.CreateFollowedChannelRequest,
  ambassadorWixLoyaltySocialmediaV1FollowedChannelUniversalTypes.CreateFollowedChannelResponse,
  ambassadorWixLoyaltySocialmediaV1FollowedChannelTypes.CreateFollowedChannelResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixLoyaltySocialmediaV1FollowedChannel.createFollowedChannel(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/followed-channels',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listFollowedChannels(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixLoyaltySocialmediaV1FollowedChannelUniversalTypes.ListFollowedChannelsRequest,
  ambassadorWixLoyaltySocialmediaV1FollowedChannelTypes.ListFollowedChannelsRequest,
  ambassadorWixLoyaltySocialmediaV1FollowedChannelUniversalTypes.ListFollowedChannelsResponse,
  ambassadorWixLoyaltySocialmediaV1FollowedChannelTypes.ListFollowedChannelsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixLoyaltySocialmediaV1FollowedChannel.listFollowedChannels(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/followed-channels',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  FollowedChannel as FollowedChannelOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  CreateFollowedChannelRequest as CreateFollowedChannelRequestOriginal,
  CreateFollowedChannelResponse as CreateFollowedChannelResponseOriginal,
  ListFollowedChannelsRequest as ListFollowedChannelsRequestOriginal,
  ListFollowedChannelsResponse as ListFollowedChannelsResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './loyalty-socialmedia-v1-followed-channel-social-media.types.js';
